module.exports = __webpack_public_path__ + "img/矩形 81@1x.a3eabd00.png";